import type { BusinessOrderExecutionPatch } from '~/lib/orders/activeExecutionsCache'

export function parseBusinessOrderExecution(raw: string): BusinessOrderExecutionPatch | null {
    try {
        const parsed = JSON.parse(raw) as unknown
        if (!parsed || typeof parsed !== 'object') {
            return null
        }
        const payload = parsed as BusinessOrderExecutionPatch
        const hasId = payload.id != null && String(payload.id).trim() !== ''
        const hasDocumentId = typeof payload.documentId === 'string' && payload.documentId.trim() !== ''
        if (!hasId && !hasDocumentId) {
            return null
        }
        return payload
    }
    catch {
        return null
    }
}
